import type { ProductKind } from '@shared/rfq';
import { useI18n } from '@/i18n';
import { Link } from '@/router';
import { CONFIGURATORS } from './registry';

export interface HeaderStep {
  id: string;
  label: string;
  state: 'current' | 'done' | 'todo';
  enabled: boolean;
}

/** Breadcrumbs, product switcher and stepper shared by every configurator. */
export function ConfiguratorHeader({ current, title, steps, onStep }: { current: ProductKind; title: string; steps: HeaderStep[]; onStep: (i: number) => void }) {
  const { d } = useI18n();
  return (
    <div className="cfg__head wrap">
      <nav className="crumbs mono" aria-label="breadcrumbs">
        <Link to="/">RDK</Link> <span aria-hidden="true">/</span> <span>{d.cfg.families[current].title}</span>
      </nav>
      <nav className="switcher" aria-label={d.cfg.switcher}>
        {CONFIGURATORS.map((c) => (
          <Link key={c.kind} to={c.route} className={`switcher__item${c.kind === current ? ' is-on' : ''}`} aria-current={c.kind === current ? 'page' : undefined}>
            {d.cfg.families[c.kind].name}
          </Link>
        ))}
      </nav>
      <h1 className="cfg__title">{title}</h1>
      <ol className="stepper" aria-label={d.cfg.families[current].title} style={{ ['--n' as string]: steps.length }}>
        {steps.map((st, i) => (
          <li key={st.id} className={`stepper__item is-${st.state}`}>
            <button type="button" disabled={!st.enabled} aria-current={st.state === 'current' ? 'step' : undefined} onClick={() => onStep(i)}>
              <span className="stepper__n mono">{String(i + 1).padStart(2, '0')}</span>
              <span className="stepper__label">{st.label}</span>
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
}
